import EditionCard from 'modules/Campaigns/Shared/EditionCard';
import EmailCardWrapperLoader from 'modules/Campaigns/Shared/EmailCardWrapperLoader';
import InfiniteLoader from 'modules/Common/Components/InfiniteLoader';
import { getQueryCampaignId } from 'modules/EmailBrowser/utils';
import { splitDayMonth } from '../../utils';
import EmptyTabInfo from 'modules/Content/Shared/EmptyTabInfo';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

function EditionsList(props: any) {
  const {
    editionsLength,
    loadMore,
    hasMore,
    editionsLoading,
    editions,
    campaignId,
    assetType,
    isSearch,
    noEmailText,
    noSearchEmailText,
    searchSentLoading,
    isScheduled,
    showEmailStats,
    noEmptyMessage,
    scheduledStyle,
    tabState,
    isWorkflowEmailsList,
  } = props;

  const emailsSearchSuccess: boolean = useSelector((state: RootState) => state.automation.userWorkflows.success); // For Alpha case in search
  const emailsSearchErrorMessage: string = useSelector((state: RootState) => state.automation.userWorkflows.message); // For Alpha case in search

  return (
    <>
      <InfiniteLoader
        dataLength={editionsLength}
        next={loadMore}
        hasMore={hasMore}
        loader={(editionsLoading || searchSentLoading || hasMore) && isSearch ? <EmailCardWrapperLoader /> : <></>}
      >
        {editions?.map((li: any, index: number) => (
          <div key={index} className="email-card" style={{ marginTop: '16px' }}>
            <EditionCard
              isScheduled={isScheduled}
              campaignId={isWorkflowEmailsList ? li.campaign_id : campaignId}
              data={li}
              assetId={getQueryCampaignId()}
              assetType={assetType}
              emailType={li.email_type}
              {...(isScheduled
                ? {
                  sent_date: li.date !== null && li.date.split(' ')[0],
                  sent_month: li.date !== null && li.date.split(' ')[1],
                }
                : {
                  sent_month: splitDayMonth(li.sent_date).month,
                  sent_date: splitDayMonth(li.sent_date).date,
                })}
              showEmailStats={showEmailStats}
              {...(isScheduled ? { scheduled_time: li.scheduled_time } : {})}
              scheduledStyle={scheduledStyle}
              automation={!!li.workflow_status}
              // automation={false} //*  Refactor Code: Remove this line and uncomment the above
              isWFActionEmail={li.workflow_status === 'wf_graph'}
              // isWFActionEmail={false} //* Refactor Code: Remove this line and uncomment the above
              tabState={tabState}
              aiTagColor={li.ai_color ? li.ai_color : '#1EC252'}
              aiTag={li.ai_type}
              generationId={li.generation_id}
              aiEmails={li.ai_emails}
              collapse
              isWorkflowEmailsList={isWorkflowEmailsList}
            />
          </div>
        ))}
      </InfiniteLoader>
      {editionsLoading && Array.from({ length: 2 }, (_, index) => <EmailCardWrapperLoader key={index} />)}
      {editionsLoading === false && editions.length === 0 && !noEmptyMessage && !hasMore ? (
        !isSearch ? (
          <EmptyTabInfo description={noEmailText} />
        ) : (
          <EmptyTabInfo description={emailsSearchSuccess ? noSearchEmailText : emailsSearchErrorMessage} />
        )
      ) : null}
    </>
  );
}

export default EditionsList;

EditionsList.defaultProps = {
  isScheduled: false,
  showEmailStats: true,
};
